import React from 'react'
import { Divider as AntDivider } from 'antd'
import { DividerProps as AntDividerProps } from 'antd/lib/divider'

type Props = AntDividerProps

export const Divider: React.FC<Props> = ({
  children,
  className,
  style,
  ...props
}) => (
  <AntDivider
    {...props}
    className={className}
    style={{ ...style, color: style?.color ?? '#d9d9d9' }}
  >
    {children}
  </AntDivider>
)
